import useTestId from '@ori/testid-generator';
import { useMemo } from 'react';
import { isNegativePpaLabel } from "./isNegativePpaLabel";
import { isPpaLabel } from "./isPpaLabel";
import { Root } from "./styles";
import { PPA_LABEL } from "../../common";
import { jsx as _jsx } from "react/jsx-runtime";
export var PpaLabel = function PpaLabel(_ref) {
  var label = _ref.label,
    type = _ref.type,
    className = _ref.className,
    productCode = _ref.productCode,
    shouldRenderEmptyLabel = _ref.shouldRenderEmptyLabel,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var isNegative = useMemo(function () {
    return isNegativePpaLabel(type);
  }, [type]);
  var isEmpty = useMemo(function () {
    return !isPpaLabel(type) || !label;
  }, [label, type]);
  if (isEmpty && !shouldRenderEmptyLabel) {
    return null;
  }
  return /*#__PURE__*/_jsx(Root, {
    className: className,
    isEmpty: isEmpty,
    isNegative: isNegative,
    size: size,
    "data-testid": "".concat(getTestId(PPA_LABEL), "-").concat(productCode),
    children: !isPpaLabel(type) && shouldRenderEmptyLabel ? null : label
  });
};
//# sourceMappingURL=PpaLabel.js.map